var arrToObj = (arr) => {
  var obj = {};
  arr.forEach((a) => {
    obj[a[0]] = a[1];
  });
  return obj;
};
let types = {
  SELECT_BOX: "select",
  SELECT_BOX2: "select2",
  SELECT_BOX3: "select3",
  SELECT_BOX4: "select4",
  RADIO_BUTTON: "radio_button",
  INPUT: "input",
  DATE_PICKER: "date_picker",
  CURRENT_TIME: "current_time",
  PASSWORD: "password",
  TEXT_AREA: "text_area",
  CHECKBOX: "checkbox",
  SPACE: "space",
  BUTTON: "button",
};
const constants = require('./constants');
let arr = [
  {
    id: "seq_id",
    label: "Unique Key",
    type: types.INPUT,
    export: {
      enabled: true,
      sequence: 1000,
    },
  },
  {
    id: "device_control_number",
    label: "機器管理番号",
    tab_size:10,
    type: types.INPUT,
    export: { 
      enabled: true,
      sequence: 1000,
      individual_linking_details: "A"
    },
  },
  {
    // 1
    id: "certificate_software_number", // Renamed from  "ref_id",
    label: "証書管理番号",
    type: types.INPUT,
    import: {
      enabled: true,
      alias: ["証書管理番号\r\n(必須)"],
    },
    export: {
      enabled: true,
      sequence: 1000,
      certificate_software_deposit:"F",
      certificate_software:"D",
      surplus_license: "C",
      individual_linking_details: "F"
    },
  },
  {
    id: "software",
    label: "ソフトウェア名",
    tab_size:30,
    type: types.INPUT,
    export: { 
      enabled: true,
      sequence: 1000,
      individual_linking_details: "G"
    },
  },
  {
    id: "item_number",
    label: "使用するライセンス数",
    tab_size:10,
    type: types.INPUT,
    error_if_blank:true,
    listen_for_value: "licence_item_number_force_update",
    field_type:"number",
    min_value:"1",
    import: { enabled: true,
    alias:["紐付本数\r\n(半角数字)"] },
    export: { 
      enabled: true,
      sequence: 1000,
      individual_linking_details: "I"
    },
  },
  {
    id: "computer_name",
    label: "コンピュータ名",
    type: types.INPUT,
    error_if_blank:true,
    import: {
      enabled: true,
      alias: ["コンピュータ名"],
    },
    export: {
      enabled: true,
      sequence: 1000,
      individual_linking_details: "B",
    },
  },
  {
    id: "jurisdiction_classification",
    label: "所管",
    tab_size:10,
    type: types.INPUT,
    export: { 
      enabled: true,
      sequence: 1000,
      individual_linking_details: "C"
    },
  },
  {
    id: "software_jurisdiction",
    label: "SW所管",
    tab_size:10,
    type: types.SELECT_BOX,
    options: [
      constants.SOFTWARE_JURISDICTION.OWN_DEPARTMENT,constants.SOFTWARE_JURISDICTION.OTHER_DEPARTMENT
    ],
    export: { 
      enabled: true,
      sequence: 1000,
      individual_linking_details: "H"
    },
  },
  {
    id: "floor",
    label: "フロア",
    tab_size:10,
    type: types.INPUT,
    export: { 
      enabled: true,
      sequence: 1000,
      individual_linking_details: "E"
    },
  },
  {
    id: "installation_base",
    label: "ビル",
    tab_size:10,
    type: types.INPUT,
    export: { 
      enabled: true,
      sequence: 1000,
      individual_linking_details: "D"
    },
  },
  {
    id: "remarks",
    label: "備考",
    tab_size:30,
    type: types.TEXT_AREA,
    export: { 
      enabled: true,
      sequence: 1000,
      individual_linking_details: "K"
    },
  },
  {
    id: "software_category",
    label: "ソフトウェアカテゴリ",
    type: types.SELECT_BOX,
    options: [
      "アプリケーション",
      "OS",
      "ミドルウェア",
      "DBソフトウェア",
      "ウイルス対策",
      "その他",
    ],
    import: { enabled: false },
    export: { 
      enabled: true,
      sequence: 1000,
      individual_linking_details: "J"
    },
  },
  {
    id: "c_remarks",
    label: "ソフトウェア備考",
    tab_size:30,
    type: types.TEXT_AREA,
    export: { 
      enabled: true,
      sequence: 1000,
      individual_linking_details: "L"
    },
  }
];
var ret = {};
var s = 1;
arr.forEach(function (e) {
  if (!RegExp("^[a-z][a-z0-9_]+$").test(e.id)) {
    alert("Invalid field " + e.id);
  }
  e["tab_label"] = e.tab_label || e.label;
  e["seq_id"] = s++;
  ret[e.id] = e;
});
ret.array = arr;
export const fields = ret;
export const filed_types = types;



// WEBPACK FOOTER //
// ./src/rules/fields_individual_linking_details.js